export default __webpack_public_path__ + "static/media/sveskupa2.05d24fcd.png";